import './index.scss';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLayoutEffect, useRef } from 'react'

gsap.registerPlugin(ScrollTrigger);
function Experience() {

  const container = useRef(null);
  const experiences = [
    {
      company: 'TAMMIRA',
      img: './company/tammira.png',
      href: 'https://www.linkedin.com/company/tammira/',
      role: 'Fullstack Developer (Freelancer)',
      techs: ['React, React-Native','Express(Node.js), MongoDB, AWS', 'SendGrid(Email  Delivery)'],
      links: [
        {
          name: 'TAMMIRA App',
          href: 'https://apps.apple.com/us/app/tammira/id1524333909'
        },

      ]
    },
    {
      company: 'Xiaoice.ai',
      img: './company/xiaoice.png',
      href: 'https://www.linkedin.com/company/xiaobing-ai/',
      role: 'Frontend Developer (Full-time)',
      techs: [
        'Vue3&Vue2, React, TypeScript, i18n',
        'D3.js, paper.js',
        'pnpm, webpack, vite',
        'Node.js, signalR(websocket)',
        'uni-app',
        'Azure, Kubernetes'
      ],
      links: [
        {
          name: 'AI Chatting',
          href: 'https://ux-plus.xiaoice.com/virtualboyfriend'
        },
        {
          name: 'Xiaoice island',
          href: 'https://island.xiaoice.com/'
        }
      ]
    },
    {
      company: 'SENSORO',
      img: './company/sensoro.png',
      href: 'https://www.linkedin.com/company/sensoro-inc./',
      role: 'Frontend Developer (Full-time) & internship',
      techs: ['Vue3&Vue2, Gulp, Webpack', 'Koa2(Node.js), Jest, MongoDB', 'Redis, Kafka, Elasticsearch'],
      links: [
        {
          name: 'IVMS(Intelligent Video Management System)',
          href: 'https://ai.sensoro.com/'
        },

      ]
    }
  ]


  useLayoutEffect(() => {
    let mm = gsap.matchMedia(container);
    mm.add("(max-width: 767px)", () => {
        gsap.utils.toArray('section').forEach((section, index) => {
        const w = section.querySelector('.experience');
        const scale = -1
        const [x, xEnd] = (index % 2) ? ['100%', 0] : [w.scrollWidth * scale, 0];
        gsap.fromTo(w, {  x  }, {
          x: xEnd,
          scrollTrigger: { 
            trigger: section,
            scrub: 0.6,
            start: "top bottom",
            end: "top center"
          }
        });
      });
    })
    mm.add("(min-width: 768px)", (ctx) => {
      gsap.utils.toArray('section').forEach((section, index) => {
        const w = section.querySelector('.experience');
        const scale = -1
        const [x, xEnd] = (index % 2) ? ['100%', 0] : [w.scrollWidth * scale, 0];
        gsap.fromTo(w, {  x  }, {
          x: xEnd,
          scrollTrigger: { 
            trigger: section,
            scrub: 0.6,
            start: "top bottom",
            end: "top center"
          }
        });
      });
    })
    return () => mm.revert();
  }, []);

  const renderItem = () => experiences.map(({company, role, href,  img, techs, links})=>(
    <section key={company}>
      <div className='experience'>
        <div>
          <p className='company'> <a target="_blank" href={href} rel="noreferrer">{company} </a><span className='role'>{role}</span></p>
          <p>Techs:</p>
          <ul>
            {techs.map(tech=>(
              <li key={tech}>{tech}</li>
            ))}
          </ul>
          <p>Links:</p>
          <ul>
            {links.map(({name, href})=>(
              <li key={name}>
                <a target="_blank" href={href} rel="noreferrer">{name}</a>
              </li>
            ))}
          </ul>
        </div>
        <img src={img} alt={company}></img>
      </div>
    </section>
  ))

  return (
    <div className='section experiences space' id='experience' ref={container}>
      <p className='title'>Experience</p>
      <p className='desc'>Look forward to working with you</p>
      <div>
        {renderItem()}
      </div>
    </div>
  );
}
export default Experience;